import { SpinnerIndicators } from '@clearkit/icons';
import classnames from 'classnames';

const Spinner = ({ className }: { className?: string }) => (
  <SpinnerIndicators className={classnames(className, 'h-12 w-12')} />
);

export default Spinner;
